const ROOTS = {
  APP: '/',
  DASHBOARD: '/dashboard',
};

const paths = {
  root: ROOTS.APP, // The root path for the home page is "/"

  page403: '/403',
  page404: '/404',

  signIn: '/sign-in',
  signUp: '/invitation',
  forgotPassword: '/forgot-password',

  sandbox: '/sandbox',

  dashboard: {
    root: ROOTS.DASHBOARD,
    textAnalysis: `${ROOTS.DASHBOARD}/text-analysis`,
    debunkedClaims: {
      list: `${ROOTS.DASHBOARD}/debunked-claims/list`,
      add: `${ROOTS.DASHBOARD}/debunked-claims/add`,
    },
    userManagement: {
      add: `${ROOTS.DASHBOARD}/user-management/add-user`,
      list: `${ROOTS.DASHBOARD}/user-management/users-list`,
    },
    profile: `${ROOTS.DASHBOARD}/profile`,
  },
};

export default paths;
